import { QueryInput } from '@/src/types/searchQuery'
import { validSearchQueryDateFormats } from '@/src/utils/date'
import { getSearchQueryObj } from '@/src/utils/srp/searchUtils'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { useSearchParams } from 'next/navigation'

dayjs.extend(customParseFormat)

const useGetSearchQueryURL: () => {
    query: string
    error: null | 'dateInPast' | 'requiredFieldsMissing'
    isRT?: boolean
    isSolutionView?: boolean
    applyInitialStopsFilter?: number | null
    isPerPaxPricingRequired?: boolean
} = () => {
    const searchParams = useSearchParams()
    const urlQueryObj = Object.fromEntries(searchParams.entries())
    const departDate = urlQueryObj.depart_date
    const returnDate = urlQueryObj.return_date
    const adults = Number(urlQueryObj?.adults)
    const from = urlQueryObj?.from
    const to = urlQueryObj?.to

    // Helper function to parse date with flexible format
    const parseDate = (dateStr: string) => {
        if (!dateStr?.trim()) return null

        // Try different date formats - all combinations of single/double digit day and month

        for (const format of validSearchQueryDateFormats) {
            const parsed = dayjs(dateStr, format)
            if (parsed.isValid()) {
                return parsed
            }
        }

        return null
    }

    //mandatory fields for search
    if (!adults || !from || !to || !departDate) {
        return {
            query: '',
            error: 'requiredFieldsMissing'
        }
    }

    //check  date is not in the past
    const parsedDepartDate = parseDate(departDate)
    const parsedReturnDate = parseDate(returnDate)
    const isDepartDateInPast = parsedDepartDate && parsedDepartDate.isBefore(dayjs(), 'day')
    const isReturnDateInPast = parsedReturnDate && parsedReturnDate.isBefore(dayjs(), 'day')
    if (isDepartDateInPast || isReturnDateInPast) {
        return {
            query: '',
            error: 'dateInPast'
        }
    }
    const searchQueryObj = getSearchQueryObj(urlQueryObj as QueryInput)
    const applyInitialStopsFilter =
        urlQueryObj.nonstop && !isNaN(Number(urlQueryObj.nonstop)) ? Number(urlQueryObj.nonstop) : null

    //adding perPaxPricingRequired
    const isPerPaxPricingRequired = !parsedReturnDate
    searchQueryObj.perPaxPricingRequired = isPerPaxPricingRequired.toString()

    const query = new URLSearchParams(searchQueryObj).toString()
    return {
        query,
        error: null,
        isRT: !!returnDate,
        isSolutionView: true,
        applyInitialStopsFilter,
        isPerPaxPricingRequired
    }
}
export default useGetSearchQueryURL
